module.exports = __webpack_public_path__ + "static/01-74d7768f3bbf95790bd878c0edff4e65.jpg";